// extracted by mini-css-extract-plugin
export var allUpper = "index-module--all-upper--vFAzT";
export var name = "index-module--name---NlUO";
export var pageWrap = "index-module--pageWrap--JmAvB";
export var self = "index-module--self--ZsmyS";
export var selfDetails = "index-module--self-details--oGz7W";